import * as React from 'react'
import Static from 'components/Static'
import Html from 'components/Html'

export default ({ discussion }) => (
  <Static>
    <Html html={discussion.content_html} />
  </Static>
)
